import { attr, hasMany, belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
export default ItemsV3Base.extend({
  name: attr('string'),
  subscriptionPhases: hasMany('subscription-phase'),
  checkoutLink: belongsTo('connect/checkout-link/data'),
  updateGloballyEnabledForRelationships(globallyEnabled) {
    this.subscriptionPhases.forEach(phase => {
      phase.set('globallyEnabled', globallyEnabled);
    });
  }
}).reopenClass({
  catalogType() {
    return 'SUBSCRIPTION_PLAN';
  },
  sortKey: 'name'
});